<template>
  <div class="row" style="padding-top:20px;" v-if="data.length>0">
    <h6>Your exams</h6>
    <data-card v-for="item in data" :data="item"></data-card>
  </div>
</template>
<script>
import DataCard from "@/components/Home/Exam/DataCard.vue";
export default {
  name: "Home",
  components: {
    "data-card": DataCard
  },
  computed: {
    data() {
      return this.$store.getters.exams;
    }
  }
};
</script>
<style lang="scss" scoped>
.box_container h6 {
  color: white !important;
  background: #e38b00;
  width: 200px !important;
  padding: 20px;
  font-size: 18px !important;
  border-radius: 150px;
  text-align: center;
  text-transform: uppercase;
}

//
</style>